import React, { useState } from 'react';

const FIELD_LABELS = {
  player: 'Player',
  operatorValue: 'Operator Value',
};

const PropDetailsParseDebug = ({ results = [] }) => {
  const [showCrops, setShowCrops] = useState(false);

  if (!results.length) return null;

  return (
    <div className="ocr-match-parse-panel ocr-prop-parse-panel">
      <div className="ocr-results-heading">
        <h4>Control Prop Details Parsed</h4>
        <p>Temporary structured output. Prop screenshots are not merged or deduplicated yet.</p>
      </div>

      <button
        type="button"
        className="ocr-crop-toggle"
        onClick={() => setShowCrops((current) => !current)}
      >
        {showCrops ? 'Hide Prop Field Crops' : 'Show Prop Field Crops'}
      </button>

      <div className="ocr-match-records">
        {results.map((result) => (
          <section className="ocr-prop-screenshot-group" key={`${result.sourceScreenshotIndex}-${result.sourceScreenshotName}`}>
            <div className="ocr-prop-screenshot-header">
              <strong>Prop Screenshot {result.sourceScreenshotIndex + 1}</strong>
              <span>{result.sourceScreenshotName}</span>
            </div>

            <div className="ocr-row-debug-meta">
              <span>Selected Team: {result.selectedTeamColor.toUpperCase()}</span>
              <span>Selected Rows: {result.selectedRowCount}</span>
              <span>Field Crops OCR'd: {result.fieldCropCount}</span>
              <span>Parse Time: {result.elapsedMs}ms</span>
            </div>

            {result.warnings.map((warning) => (
              <p className="ocr-row-warning" key={warning}>{warning}</p>
            ))}

            {result.records.map((record, index) => (
              <article className="ocr-match-record" key={`${record.sourceScreenshotIndex}-${record.sourceRowId}-${index}`}>
                <header>
                  <strong>Row {record.sourceRowIndex + 1}</strong>
                  <span>{record.detectedName || 'Name not detected'}</span>
                </header>

                <dl className="ocr-prop-fields">
                  <div>
                    <dt>Player</dt>
                    <dd>{record.detectedName || 'FAILED'}</dd>
                  </div>
                  <div>
                    <dt>Operator Value</dt>
                    <dd>{record.operatorValue ?? 'FAILED'}</dd>
                  </div>
                </dl>

                {record._warnings.length > 0 && (
                  <div className="ocr-field-warnings">
                    {record._warnings.map((warning) => (
                      <p key={warning}>{warning}</p>
                    ))}
                  </div>
                )}

                <div className="ocr-field-confidence">
                  {Object.entries(record._ocr).map(([fieldKey, field]) => (
                    <span key={fieldKey}>
                      {FIELD_LABELS[fieldKey]}: {typeof field.confidence === 'number' ? `${Math.round(field.confidence)}%` : 'N/A'}
                      {field.raw ? ` - Raw: "${field.raw}"` : ''}
                    </span>
                  ))}
                </div>

                {showCrops && (
                  <div className="ocr-crop-grid ocr-prop-crop-grid">
                    {Object.entries(record._crops).map(([fieldKey, crop]) => (
                      <figure key={fieldKey}>
                        <img src={crop.previewUrl} alt={`${FIELD_LABELS[fieldKey]} crop`} />
                        <figcaption>{FIELD_LABELS[fieldKey]}</figcaption>
                      </figure>
                    ))}
                  </div>
                )}
              </article>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
};

export default PropDetailsParseDebug;
